import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconArrowRight } from '@redteclab/icons'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../../../../global-config'
import { urlResolverGetRegister } from '../../../../../../url-handling'

export const HeaderRegistration: FC = () => {
  const globalConfig = useGlobalConfigContext()

  return (
    <div className="mb-4 flex flex-wrap items-center text-m font-normal text-dark-primary-strong">
      <FormattedMessage id="menubar.AccountFlyout.label.newCustomer" />
      <Button
        className="mt-0.5 w-full justify-between text-dark-brand"
        endIcon={<IconArrowRight />}
        href={urlResolverGetRegister(globalConfig)}
        size="large"
        variant="text"
      >
        <FormattedMessage id="general.link.label.registerNow" />
      </Button>
    </div>
  )
}
